import React, { useState, useEffect, useRef } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import MovieCard from '../movie-card/MovieCard';

const GenreMovieList = ({ genreId, size = 12 }) => {
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);
    const [isBeginning, setIsBeginning] = useState(true);
    const [isEnd, setIsEnd] = useState(false);
    const swiperRef = useRef(null);

    useEffect(() => {
        if (!genreId) return;
        setLoading(true);
        fetch(`/movies-public-api.php?type=byGenre&genreId=${genreId}&page=0&size=${size}`)
            .then(r => r.json())
            .then(d => { if (d.success) setItems(d.content || []); })
            .catch(() => {})
            .finally(() => setLoading(false));
    }, [genreId, size]);

    const updateNav = s => { setIsBeginning(s.isBeginning); setIsEnd(s.isEnd); };

    if (loading) return <div style={{ padding: '20px 0', color: '#555' }}>Loading...</div>;
    if (!items.length) return null;

    return (
        <div className="ranked-list" style={{ position: 'relative' }}>
            {!isBeginning && (
                <button className="ranked-list__nav ranked-list__nav--prev" onClick={() => swiperRef.current?.slidePrev()}>
                    <FaChevronLeft />
                </button>
            )}
            {!isEnd && (
                <button className="ranked-list__nav ranked-list__nav--next" onClick={() => swiperRef.current?.slideNext()}>
                    <FaChevronRight />
                </button>
            )}
            <Swiper
                grabCursor
                spaceBetween={8}
                slidesPerView="auto"
                onSwiper={s => { swiperRef.current = s; updateNav(s); }}
                onSlideChange={updateNav}
            >
                {items.map(item => (
                    <SwiperSlide key={item.id} style={{ width: 'auto' }}>
                        <MovieCard item={{
                            id: item.id,
                            title: item.title,
                            poster_path: item.posterUrl,
                            backdrop_path: item.thumbnailUrl || item.posterUrl,
                            slug: item.slug,
                            releaseYear: item.releaseYear,
                            duration: item.duration,
                            averageRating: item.averageRating,
                            episodeCount: item.episodeCount,
                            status: item.status,
                            genres: item.genres,
                            description: item.description,
                            country: item.country,
                        }} />
                    </SwiperSlide>
                ))}
            </Swiper>
        </div>
    );
};

export default GenreMovieList;
